import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryTags() {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">
          漫画分类
        </h2>
        <div className="grid grid-cols-4 md:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all group"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}